import request from '.';

export default function getSigningCompany(data) {

    return request({
        url: 'v1/contractCenter/getSigningCompany',
        method: 'post',
        data,
    });
}
